import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.jungleclick.online/api";

const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    }
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const segmentationCSTsByModeNegativization = async (searchTermsArray) => {
    console.log("Datos recibidos en segmentationCSTsByModeNegativization:", searchTermsArray); // Verifica los datos de entrada
    try {

        const accountId = searchTermsArray.accountId;

        for (const searchTerms of searchTermsArray) {
            console.log(`Processing mode: ${searchTerms.modalidad}`);
            console.log("Datos a procesar:", searchTerms.csts);

            switch (searchTerms.modalidad) {
                case 1:
                    console.log("Iniciando negativización por Respectivo Adgroup... ", searchTerms.csts);
                    await negativizeCSTsByRespectiveAdgroup(searchTerms.csts, accountId);
                    console.log("Negativización por Respectivo Adgroup completada.");
                    break;

                case 2:
                    console.log("Iniciando negativización por Todos los Adgroups...", searchTerms.csts);
                    await negativizeCSTsByAllAdgroups(searchTerms.csts, accountId);
                    console.log("Negativización por Todos los Adgroups completada.");
                    break;
                case 3:
                    console.log("Iniciando negativización por Selección de Adgroups...", searchTerms.csts);
                    await negativizeCSTsBySelectAdgroups(searchTerms.csts, accountId);
                    console.log("Negativización por Selección de Adgroups completada.");
                    break;

                case 4:
                    console.log("Iniciando negativización por Respectiva Campaign...", searchTerms.csts);
                    await negativizeCSTsByRespectiveCampaign(searchTerms.csts, accountId);
                    console.log("Negativización por Respectiva Campaign completada.");
                    break;

                case 5:
                    console.log("Iniciando negativización por Todas las Campaigns...", searchTerms.csts);
                    await negativizeCSTsByAllCampaigns(searchTerms.csts, accountId);
                    console.log("Negativización por Todas las Campaigns completada.");
                    break;

                case 6:
                    console.log("Iniciando negativización por Selección de Campaigns...", searchTerms.csts);
                    await negativizeCSTsBySelectCampaigns(searchTerms.csts, accountId);
                    console.log("Negativización por Selección de Campaigns completada.");
                    break;

                case 7:
                    console.log("Iniciando negativización por Respective Portfolio...", searchTerms.csts);
                    await negativizeCSTsByRespectivePortfolio(searchTerms.csts, accountId);
                    console.log("Negativización por Respective Portfolio completada.");
                    break;

                case 8:
                    console.log("Iniciando negativización por Todos los Portfolios...", searchTerms.csts);
                    await negativizeCSTsByAllPortfolios(searchTerms.csts, accountId);
                    console.log("Negativización por Todos los Portfolios completada.");
                    break;

                case 9:
                    console.log("Iniciando negativización por Selección de Portfolios...", searchTerms.csts);
                    await negativizeCSTsBySelectPortfolios(searchTerms.csts, accountId);
                    console.log("Negativización por Selección de Portfolios completada.");
                    break;

                case 10:
                    console.log("Iniciando negativización por Respectivo ASIN...", searchTerms.csts);
                    await negativizeCSTsByRespectiveASIN(searchTerms.csts, accountId);
                    console.log("Negativización por Respectivo ASIN completada.");
                    break;

                case 11:
                    console.log("Iniciando negativización por Todos los ASINs...", searchTerms.csts);
                    await negativizeCSTsByAllASINs(searchTerms.csts, accountId);
                    console.log("Negativización por Todos los ASINs completada.");
                    break;

                case 12:
                    console.log("Iniciando negativización por Selección de ASINs...", searchTerms.csts);
                    await negativizeCSTsBySelectASINs(searchTerms.csts, accountId);
                    console.log("Negativización por Selección de ASINs completada.");
                    break;

                default:
                    console.warn(`Modalidad no reconocida: ${searchTerms.modalidad}`);
                    break;
            }
        }
    } catch (error) {
        console.error("Error en segmentationCSTsByModeNegativization:", error);
        throw new Error(error.response?.data?.message || "Error segmenting CSTs by mode");
    }
};

export const negativizeCSTsByRespectiveAdgroup = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post("/negativization/respectiveAdgroup", { data: searchTerms, accountId: accountId });
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by respective ad group");
    }
}

export const negativizeCSTsByAllAdgroups = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/allAdgroups`, { data: searchTerms, accountId: accountId });
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs for all ad groups");
    }
}

export const negativizeCSTsBySelectAdgroups = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/selectAdgroups`, { data: searchTerms, accountId: accountId });
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs for selected ad groups");
    }
}


export const negativizeCSTsByRespectiveCampaign = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post("/negativization/respectiveCampaign", { data: searchTerms, accountId: accountId });
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by respective campaign");
    }
}

export const negativizeCSTsByAllCampaigns = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/allCampaigns`, { data: searchTerms, accountId: accountId });
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by all campaigns");
    }
}

export const negativizeCSTsBySelectCampaigns = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/selectCampaigns`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by selected campaigns");
    }
}

export const negativizeCSTsByRespectivePortfolio = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/respectivePortfolio`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by respective portfolio");
    }
}

export const negativizeCSTsByAllPortfolios = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/allPortfolios`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by all portfolios");
    }
}

export const negativizeCSTsBySelectPortfolios = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/selectPortfolios`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by selected portfolios");
    }
}

export const negativizeCSTsByRespectiveASIN = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/respectiveASIN`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by respective ASIN");
    }
}

export const negativizeCSTsByAllASINs = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/allASINs`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by all ASINs");
    }
}

export const negativizeCSTsBySelectASINs = async (searchTerms, accountId) => {
    try {
        console.log(searchTerms);
        const response = await apiClient.post(`/negativization/selectASINs`, { data: searchTerms, accountId: accountId })
        console.log("El status del response es:", response.status);
        console.log("Data del response es:", response.data);
        return true;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error negativizing CSTs by selected ASINs");
    }
}

export const getNegativizationModes = async () => {
    try {
        const response = await apiClient.get(`/negativizationModes`);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error fetching negativization modes");
    }
};


export const archivationCST = async (idKeyword, accountId) => {
    try {
        console.log("Entering CST archivation");
        console.log(idKeyword);
        //para metodo delete de axios, el body se envia a partir de un campo "data"
        const response = await apiClient.delete(`/negativization/archive`, { data: { id: idKeyword, accountId: accountId } });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error archiving CST term");
    }
};

export const archivationExpress = async (idKeyword, accountId) => {
    try {
        console.log(idKeyword);
        //para metodo delete de axios, el body se envia a partir de un campo "data"
        const response = await apiClient.delete(`/express/archive`, { data: { id: idKeyword, accountId: accountId } });
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.message || "Error archiving Express term");
    }
};
